export default __webpack_public_path__ + "static/media/ferry-station.e538755c.svg";